import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Page, PageMetadata } from '@tran-monorepo/interfaces';
import { SubjectArea } from '@tran-monorepo/interfaces/applications';
import { SortOrder } from '@tran-monorepo/interfaces/pagination';
import { Observable } from 'rxjs';

export const SUBJECT_AREAS_API_URL = new InjectionToken<string>('SUBJECT_AREAS_API_URL');

@Injectable({ providedIn: 'root' })
export class SubjectAreasService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(SUBJECT_AREAS_API_URL);

    public getSubjectAreas(
        page = 0,
        pageSize = 20,
        orderBy = 'name',
        sortOrder = SortOrder.ASC
    ): Observable<Page<SubjectArea, PageMetadata>> {
        const params = new HttpParams({
            fromObject: { page, pageSize, orderBy, sortOrder }
        });

        return this.http.get<Page<SubjectArea, PageMetadata>>(this.apiUrl, {
            params
        });
    }
}
